/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Dialog_LabelInputs */

const en_us2_swap_dialog_label = /** @type {(inputs: Swap_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap exercise`)
};

const pt_br2_swap_dialog_label = /** @type {(inputs: Swap_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar exercício`)
};

const es_419_swap_dialog_label = /** @type {(inputs: Swap_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar ejercicio`)
};

const pt_pt2_swap_dialog_label = /** @type {(inputs: Swap_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trocar exercício`)
};

const fr_fr2_swap_dialog_label = /** @type {(inputs: Swap_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer d'exercice`)
};

const de_de2_swap_dialog_label = /** @type {(inputs: Swap_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung tauschen`)
};

const it_it2_swap_dialog_label = /** @type {(inputs: Swap_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia esercizio`)
};

/**
* | output |
* | --- |
* | "Swap exercise" |
*
* @param {Swap_Dialog_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_dialog_label = /** @type {((inputs?: Swap_Dialog_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Dialog_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_dialog_label(inputs)
	if (locale === "es-419") return es_419_swap_dialog_label(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_dialog_label(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_dialog_label(inputs)
	if (locale === "de-DE") return de_de2_swap_dialog_label(inputs)
	if (locale === "it-IT") return it_it2_swap_dialog_label(inputs)
	return en_us2_swap_dialog_label(inputs)
});
export { swap_dialog_label as "swap.dialog_label" }